import { InvoicesFilters } from "@/components/shared/invoices-filters";
import { useExportHistory } from "@/providers/invoices";

import type { InvoiceTypeString } from "@/lib/constants/invoice-type";
import type { InvoiceFilterFields } from "@/types/utils";
import { useDocumentSotringTableInstance } from "./table-instance-provider";

type Props = {
  data: any;
  onFilter: React.Dispatch<React.SetStateAction<any[]>>;
  filtersConfig: {
    showStatusFilter?: boolean;
    showAccountFilter?: boolean;
    showSupplierFilter?: boolean;
    showExportsFilter?: boolean;
    showUploadButton?: boolean;
    showOcrReviewedFilter?: boolean;
    showExportAllButton?: boolean;
  };
  filters: InvoiceFilterFields;
  setFilters: (filters: InvoiceFilterFields) => void;
  globalSearch: string;
  setGlobalSearch: (globalSearch: string) => void;
  invoiceType?: InvoiceTypeString;
};

export const DocumentSortingFilters = ({
  data,
  filtersConfig = {},
  filters,
  setFilters,
  globalSearch,
  setGlobalSearch,
  invoiceType,
}: Props) => {
  const { table } = useDocumentSotringTableInstance();

  const { exportHistory } = useExportHistory();

  return (
    <InvoicesFilters
      data={data}
      exportHistory={exportHistory}
      table={table}
      filtersConfig={filtersConfig}
      filters={filters}
      setFilters={setFilters}
      globalSearch={globalSearch}
      setGlobalSearch={setGlobalSearch}
      invoiceType={invoiceType}
    />
  );
};
